import { lineItemFieldSettings, LineItemFieldSettings } from '@/services/networks/networkFieldSettings'
import { useNetworkProfile } from '../contexts/NetworkProfileContext'

/**
 * Objective and bid fields the current network allows for this kind of line item.
 * Marketplace (product-backed) line items get their own set of settings.
 *
 * Read from the shared network profile, which starts from the copy the last
 * visit stored, so a reload lays the form out correctly on first paint instead
 * of showing every field and hiding the disallowed ones once the request lands.
 */
export function useLineItemFieldSettings(isMarketplace: boolean): LineItemFieldSettings & {
  ready: boolean
} {
  const { networkProfile, isError } = useNetworkProfile()
  return { ...lineItemFieldSettings(networkProfile, isMarketplace), ready: !!networkProfile || isError }
}
